import React from 'react';
import {Container} from 'react-bootstrap'
import Slider from 'react-slick'
import BlogCard from './BlogCard'
import {NextArrowCarusel,  PrevArrowCarusel} from '~/shared/ArrowsCarousel'

import { Content } from './styles';

const Blog = () => {

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        autoplay: true,
        autoplaySpeed: 2000,
        centerPadding: "60px",
        nextArrow: <NextArrowCarusel />,
        prevArrow: <PrevArrowCarusel />,

        responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },

            {
                breakpoint: 414,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
              }
        ],

      }

  return (
      <Container>
          <Content>
              <div className="blog-title">
                  <p>Conheça nosso <strong>blog</strong></p>
              </div>

              <div className="cards-blog">
                  <Slider {...settings}>
                      <BlogCard
                        title="EMPRESA B2B"
                        image='/images/blog-card-01.jpeg'
                        text="5 tendências que moldarão a indústria de fotografia de produtos em 2022"
                        link="http://blog.fotop.io/2022/02/18/5-tendencias-que-moldarao-a-industria-de-fotografia-de-produtos-em-2022/"
                      />

                      <BlogCard
                        title="EMPRESA B2B"
                        image='/images/blog-card-02.jpeg'
                        text="Como empreender com a fotografia em 2022"
                        link="http://blog.fotop.io/2022/02/08/como-empreender-com-a-fotografia-em-2022/"
                      />

                      <BlogCard
                        title="EMPRESA B2B"
                        image='/images/blog-card-03.jpeg'
                        text="Fotop marca presença no L'Etape Ecuador"
                        link="http://blog.fotop.io/2022/02/11/fotop-marca-presenca-no-letape-ecuador/"
                      />


                      <BlogCard
                        title="EMPRESA B2B"
                        image='/images/blog-card-04.jpeg'
                        text="Razões pelas quais a fotografia é importante no marketing de mídia social"
                        link="http://blog.fotop.com.br/2022/01/28/razoes-pelas-quais-a-fotografia-e-importante-no-marketing-de-midia-social/"
                      />

                      <BlogCard
                        title="FOTÓGRAFOS"
                        image='/images/blog-card-05.jpeg'
                        text="Não se contentar com a foto que já tem é o segredo do fotógrafo que cobriu o Dakar 2022"
                        link="http://blog.fotop.io/2022/02/11/fotop-marca-presenca-no-letape-ecuador/"
                      />

                  </Slider>
              </div>
          </Content>
      </Container>
  )
}

export default Blog;
